import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { useEffect, useState } from "react"
import { Grid } from "@mui/material"
import formations from "../services/formations"
import { AcademicLevel, Campus, Consentement, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Dropdown, Email, InputText, PhoneNumber } from "components/fields"
import { useForms, useSalesforce } from "hooks"
import { consent, defaultValues, getAcademicLevels, getCampus } from "services"

const Form = () => {
  const { recordTypeId, salesforce, setError, setOpenSnackbar } = useForms()
  // Styles
  // Form
  const methods = useForm({
    defaultValues: {
      ...consent,
      campaignId: '',
      lead: {
        ...defaultValues,
        Wished_Programm__c: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control, setValue, watch } = methods
  // State
  const [campaigns, setCampaigns] = useState([])
  // Submit form
  const onSubmit = async data => {
    setOpenSnackbar(false)
    const lead = data.lead
    const campaignId = data.campaignId
    const defaultDataLead = {
      Division__c: 'e-artsup',
      IONISSchool__c: 'e-artsup',
      LastForm__c: 'pre-candidature',
      LeadSource: 'Pré-candidature',
      RecordTypeId: recordTypeId
    }
    const finalLead = {...lead, ...defaultDataLead}
    try {
      const leadCreated = await salesforce.createLead(finalLead)
      if (campaignId !== '') {
        const campaignMember = {
          CampaignId: campaignId,
          LeadId: leadCreated.Id,
          Status: 'Pre-application'
        }
        await salesforce.createCampaignMember(campaignMember)
      }
      document.location.href=`https://www.e-artsup.net/retour-candidature-2/?ville=${campus}&campaignId=${campaignId}`
    } catch (error) {
      setError('Une erreur est survenue lors de la soumission du formulaire', error)
    }
  }
  // Watch
  const campus = watch('lead.Campus__c')
  // useEffect
  useEffect(() => {
    if (salesforce !== null) {
      const getData = async () => {
        const campaigns = await salesforce.getCampaignsCandidature('e-artsup', 'e-artsup', 'Candidature')

        return { campaigns }
      }

      getData().then((value) => {
        const { campaigns } = value
        setCampaigns(campaigns)
        // setOpenBackdrop(false)
      }).catch((error) => {
        setError('Une erreur est survenue lors du chargement du formulaire', error)
      })
    }
  }, [salesforce, setError])

  useSalesforce('BusinessSchoolLead')

  useEffect(() => {
    if (campus !== '') {
      const campaign = campaigns.find(el => el.Campus__c === campus)
      if (campaign !== undefined) {
        setValue('campaignId', campaign.Id)
      }
    }
  }, [campaigns, campus, setValue])

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Campus label="Campus d'intérêt" options={getCampus('e-artsup')} />
        <Grid item xs={12}>
          <Dropdown control={control} label="Programme d'intérêt" name="lead.Wished_Programm__c" options={formations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone mobile" required />
        </Grid>
        <AcademicLevel options={getAcademicLevels('e-artsup')} school="e-artsup" section={false} />
        <ConsentementMultiple />
        <RequiredFields />
        <Submit label="Valider ma pré-candidature" onSubmit={onSubmit} />
        <MentionsLegales form="Candidature" school="e-artsup" />
      </Grid>
    </FormProvider>
  )
}

export default Form
